import { Cookie } from "../cookie/cookie";


export class Session {
    sessionId = '';

    events = {
        open: 'open-session',
        close: 'close-session'
    };

    constructor() {
        this.init();
    }

    init() {
        this.bindEvents();
    }

    // fn's
    getStatus() {
        const cookie = new Cookie();

        return !!cookie.get(this.sessionId);
    }

    getEvents(e) {
        return events[e] || events;
    }

    bindEvents() {
        $(window).on('close-session', (e, args) => this.onClose(e, args));
    }

    onClose(e, args) {
        e.preventDefault();
        this.close(args);
    }

    // auxiliary
    close(args) {
        const url = args.url;
        this.reloadWindow(url);
    }

    reloadWindow(url) {
        url ? window.location.replace(url) : window.location.reload(true);
    }
}
